import { useCallback, useState } from "react";

export const useSaveParamsURL = () => {
  const [countryIso, setCountryIso] = useState("");
  const [languageIso, setLanguageIso] = useState("");
  const [detailId, setDetailId] = useState("");
  const [showDraftMode, setShowDraftMode] = useState(false);
  const [originURL, setOriginURL] = useState("");
  const [darkMode, setDarkMode] = useState(false);

  const modifyParams = useCallback(
    (
      newCountryIso,
      newLanguageIso,
      newDetailId,
      newShowDraftMode,
      newOriginURL,
      newDarkMode
    ) => {
      setCountryIso(newCountryIso);
      setLanguageIso(newLanguageIso);
      setDetailId(newDetailId);
      setShowDraftMode(newShowDraftMode);
      setOriginURL(newOriginURL);
      setDarkMode(newDarkMode);
    },
    []
  );

  return {
    countryIso,
    languageIso,
    detailId,
    showDraftMode,
    originURL,
    modifyParams,
    setDetailId,
    darkMode,
  };
};
